import { defineComponent as r, ref as i, openBlock as l, createBlock as d, unref as o, withCtx as s, renderSlot as c, createVNode as g } from "vue";
import { loadingBarTrigger as f } from "./ghl-ui.es345.js";
import u from "./ghl-ui.es346.js";
const B = r({
  name: "UILoadingBar"
}), y = r({
  ...B,
  props: {
    containerClass: {
      type: String,
      default: void 0
    },
    containerStyle: {
      type: [String, Object],
      default: void 0
    },
    loadingBarStyle: {
      type: Object,
      default: void 0
    },
    to: {
      type: [String, HTMLElement, Boolean],
      default: void 0
    }
  },
  setup(t, { expose: n }) {
    const a = i();
    return n({
      startLoadBar: () => {
        var e;
        (e = a.value) == null || e.startLoading();
      },
      stopLoadBar: () => {
        var e;
        (e = a.value) == null || e.finishLoading();
      },
      errorLoadBar: () => {
        var e;
        (e = a.value) == null || e.errorLoading();
      }
    }), (e, v) => (l(), d(o(u), {
      "container-class": t.containerClass,
      "container-style": t.containerStyle,
      to: t.to,
      "loading-bar-style": t.loadingBarStyle
    }, {
      default: s(() => [
        c(e.$slots, "default"),
        g(o(f), {
          ref_key: "loadingTriggerRef",
          ref: a
        }, null, 512)
      ]),
      _: 3
    }, 8, ["container-class", "container-style", "to", "loading-bar-style"]));
  }
}), T = y;
export {
  T as default
};
